export interface HoaDonMuaHangTrongNuocTableTabConfig {
  key: string;
  name: string;
  status?: string;
  color?: string;
}

export const TABLE_PAGE_SIZE = 500;

export const HOA_DON_MUA_HANG_TRONG_NUOC_TABLE_TABS: HoaDonMuaHangTrongNuocTableTabConfig[] = [
  {
    key: 'all',
    name: 'Tất cả'
  },
  {
    key: 'draft',
    name: 'Lập chứng từ',
    status: '0',
    color: '#EAD1DC'
  },
  {
    key: 'pending',
    name: 'Chờ duyệt',
    status: '3',
    color: '#ef4444'
  },
  {
    key: 'posted',
    name: 'Xuất hóa đơn',
    status: '5',
    color: '#3D85C6'
  }
];
